/** Czech counts the places three ways, so the whole clause is built per count
 *  rather than glued from a number and a noun. */
export function unfinishedCheckoutsNote(count: number): string {
  const held =
    count === 1
      ? "Jedno místo drží nedokončená platba"
      : count < 5
        ? `${count} místa drží nedokončené platby`
        : `${count} míst drží nedokončené platby`;
  return `${held}, proto je u slevového termínu obsazeno víc míst než rezervací v seznamu. Rezervace se tu objeví, až platba proběhne; když neproběhne, místo se samo uvolní.`;
}
